var map = {
	"./AKRED.png": 1519,
	"./AKREDCOM.png": 9736,
	"./AKREDMANUAL.png": 8437,
	"./AUMS.png": 9890,
	"./AUMSMANUAL.png": 1628,
	"./Apply in DNSC Page Toturial5.mp4": 3359,
	"./CORETIME UPDATED.mp4": 3599,
	"./DNSC In-House Developed Systems Video Presentation.mp4": 23,
	"./DNSC Procurement Management System.mp4": 1978,
	"./DNSC.png": 5623,
	"./FPS.png": 3763,
	"./FPSMANUAL.png": 1897,
	"./FRSCOM.png": 4798,
	"./FRSMANUAL.png": 4179,
	"./Finding your way around.mp4": 7982,
	"./GATEWAY.png": 1112,
	"./GATEWAYMANUAL.png": 9118,
	"./GATEWAY_LOGO.png": 8244,
	"./HRIS.png": 306,
	"./HRISCOM.png": 1395,
	"./HRISMANUAL.png": 2364,
	"./HRISMANUAL1.png": 1903,
	"./IAIMS.png": 1421,
	"./ISRF.png": 7544,
	"./Information System Gateway.mp4": 6531,
	"./KNOWS.png": 7882,
	"./KNOWSCOM.png": 4827,
	"./LIS.png": 2014,
	"./LMS.png": 9690,
	"./LMSCOM.png": 3899,
	"./LMSMANUAL.png": 948,
	"./OSFF.png": 8854,
	"./PIO.png": 4774,
	"./PMS.png": 8782,
	"./RFID.png": 1127,
	"./RMS.png": 3816,
	"./RMSCOM.png": 3421,
	"./RMSMANUAL.png": 1886,
	"./TSSU.png": 3871,
	"./ab.png": 4861,
	"./bagongpilipinas.png": 6367,
	"./bap-1.jpg": 8905,
	"./bap-2.jpg": 238,
	"./bap.jpg": 6311,
	"./bg.png": 8337,
	"./bg1.png": 5724,
	"./corseal.png": 3073,
	"./dnsc-dpo.png": 8048,
	"./dnsc-green.png": 1466,
	"./dnsc-logo-white.png": 4090,
	"./dnsc-white.png": 1924,
	"./dnsc_logo.png": 9872,
	"./dnsclogo.png": 1557,
	"./dots.png": 5176,
	"./down.png": 7436,
	"./edjec-1.jpg": 8375,
	"./edjec-2.jpg": 7448,
	"./edjec.jpg": 309,
	"./globe-blue.gif": 9624,
	"./globe-gray.gif": 818,
	"./globe-green.gif": 828,
	"./hris-logo.png": 5188,
	"./ian-1.jpg": 5060,
	"./ian.jpg": 6710,
	"./iso.jpg": 6313,
	"./jinnah-1.jpg": 2618,
	"./jinnah-2.jpg": 4693,
	"./jinnah.jpg": 9556,
	"./lis-logo.png": 5824,
	"./logos.png": 8802,
	"./mark-1.jpg": 1205,
	"./mark.jpg": 8411,
	"./new_bg.png": 6060,
	"./portal.png": 2658,
	"./props1.png": 6691,
	"./registration.jpg": 5899,
	"./socotecdnsc.png": 9842,
	"./up.png": 9923,
	"./yong-1.jpg": 1195,
	"./yong.jpg": 8001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;